import EllipsisLoading from '@/components/EllipsisLoading'
import { actionButtonSx } from '@/theme'
import { Button } from '@mui/material'

import ChargingPointScreenTemplate from './template/ChargingPointScreenTemplate'
import { ChargingPointScreenProps } from './types'

import ChargingSessionBody from '../components/ChargingSessionBody'

const StartingChargingSessionScreen: React.FC<ChargingPointScreenProps> = (props) => {
  return (
    <ChargingPointScreenTemplate
      {...props}
      Body={
        <ChargingSessionBody
          message={
            <>
              Iniciando carregamento <EllipsisLoading />
            </>
          }
        />
      }
      Footer={
        <Button variant="contained" color="primary" disableElevation fullWidth loading sx={actionButtonSx}>
          Iniciar carregamento
        </Button>
      }
    />
  )
}

export default StartingChargingSessionScreen
